export const PRODUCT_VERSION_MAJOR = 8;
export const PRODUCT_VERSION_MINOR = 2;
export const PRODUCT_VERSION_SHORT = `v${PRODUCT_VERSION_MAJOR}`;
export const PRODUCT_VERSION = `v${PRODUCT_VERSION_MAJOR}.${PRODUCT_VERSION_MINOR}`;
